import {LogLevel} from '@azure/msal-browser'
export const msalConfig={
auth:{
    clientId:'3ff96714-404d-4a63-9839-29d64f700b43',
    authority:'https://login.microsoftonline.com/iparth.com',
    redirectUri:'https://iparth.com/',
    postLogoutRedirectUri:'/',
    navigateToLoginRequestUrl:false
},
cache:{
    cacheLocation:'sessionStorage',
    storeAuthStateInCookie:false

},
system:{
    loggerOption:{
        loggerCallback:(level,message,containsPii)=>{
            if(containsPii){
                return ;
            }
            switch(level){
                case LogLevel.Error:
                    console.log(message);
                    return;
                case LogLevel.Info:
                    console.info(message);
                    return;
                case LogLevel.Verbose:
                    console.debug(message)   
                    return;
                default:
                    return;     
            }
        }
    }
}
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export const loginRequest={
    scopes:['user.read'],
};
